import Form from "../classes/Form";

export default function (httpClient, store) {
	return {
		methods: {
			newForm(data) {
				return new Form(data).setHttpClient(httpClient).setStore(store);
			},
		},
	};
};
